// extracted by mini-css-extract-plugin
module.exports = {"card":"project_card__SIPd1"};